import script from "./ProductVariantDeliveryDays.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductVariantDeliveryDays.vue?vue&type=script&setup=true&lang=ts"

import "./ProductVariantDeliveryDays.vue?vue&type=style&index=0&id=0059c344&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0059c344"]])

export default __exports__